import { render, staticRenderFns } from "./ReviewLicense.vue?vue&type=template&id=78c77df4&scoped=true&"
import script from "./ReviewLicense.vue?vue&type=script&lang=ts&"
export * from "./ReviewLicense.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewLicense.vue?vue&type=style&index=0&id=78c77df4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c77df4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
